import Vue from "vue";
import { createPinia, PiniaPlugin } from "pinia";

Vue.use(PiniaPlugin);

export const pinia = createPinia();
